module.exports = __webpack_public_path__ + "static/media/Forestman.7adce82a.jpg";